import { Text } from 'native-base';
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from '../../../../../utils/fonts';
import { COLORS } from '../../../../../utils/colors';
import NewTextAreaField from '../../../../../components/textArea/newTextArea';
import TodoList from '../../../../../components/toDo';

export const EventPlanTextCards = ({
  text,
  name,
  defaultData,
  setDefaultData,
  childref,
  agendaRef,
  type,
}) => {
  const onInputChange = (e, eName) => {
    let data = { ...defaultData };
    if (eName === 'menu') {
      // Handle menu data properly
      data[eName] = e;
    } else {
      data[eName] = e.target.value;
    }
    setDefaultData(data);
  };

  return (
    <>
      <Text
        fontWeight={COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT}
        fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
        color={COLORS.ATTACHMENTS_TEXT_COLOR}
        pb={'12px'}
      >
        {text}
      </Text>

      {name === 'agenda' ? (
        <NewTextAreaField
          borderRadius={'8px'}
          name={name}
          value={defaultData.agenda}
          onChange={onInputChange}
          placeholder={`Enter ${name} details`}
          transparent={true}
        />
      ) : (
        <TodoList
          name='menu'
          value={type === 'agenda' ? defaultData?.agenda : (defaultData.menu || [])}
          onChange={onInputChange}
          type={type === 'agenda' ? 'agenda' : 'menu'}
          ref={type === 'agenda' ? agendaRef : childref}
        />
      )}
    </>
  );
};
